<div [class]="containerClass">
  @if (leftIcon) {
    <lucide-icon [name]="leftIcon" [size]="24" class="hc-input__icon hc-input__icon--left" aria-hidden="true"></lucide-icon>
  }
  @if (prefix) {
    <span class="hc-input__prefix">{{ prefix }}</span>
  }
  <input
    #inputEl
    [type]="effectiveType"
    [id]="inputId"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [value]="value"
    [autocomplete]="autocomplete"
    [attr.min]="min || null"
    [attr.max]="max || null"
    [attr.step]="step || null"
    [attr.maxlength]="maxlength || null"
    [attr.minlength]="minlength || null"
    [attr.pattern]="pattern || null"
    class="hc-input__native"
    (input)="onInput($event)"
    (keypress)="onKeypress($event)"
    (focus)="onFocus()"
    (blur)="onBlur()" />
  @if (suffix) {
    <span class="hc-input__suffix">{{ suffix }}</span>
  }
  @if (showPasswordToggle) {
    <button type="button" class="hc-input__password-toggle" (click)="togglePasswordVisibility()" [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'" tabindex="-1">
      <lucide-icon [name]="passwordVisible ? 'eye' : 'eye-off'" [size]="20" aria-hidden="true"></lucide-icon>
    </button>
  } @else if (rightIcon) {
    <lucide-icon [name]="rightIcon" [size]="24" class="hc-input__icon hc-input__icon--right" aria-hidden="true"></lucide-icon>
  }
</div>
